<template>
<div id="Dotsandboxes" class="routes_components dots_and_boxes_view">
  <div class="row score_row score_4x4" v-if="show_4x4">
    <div class="col text-right score_div">
      <span id="player_won_4" v-b-popover.bottom="'Won'">You <span class="score">{{player_boxes_4}}</span></span>
    </div>
    <div class="col text-center score_div">
      <span id="boxes_tie_4" v-b-popover.bottom="'Tie'">Boxes <span class="score">{{boxes_4}}</span></span>
    </div>
    <div class="col text-left score_div">
      <span id="bot_won_4" v-b-popover.bottom="'Won'">&nbsp;&nbsp;&nbsp;&nbsp;Bot <span class="score">{{bot_boxes_4}}</span></span>
    </div>
  </div>
  <div class="row score_row score_8x8" v-if="show_8x8">
    <div class="col text-right score_div">
      <span id="player_won_8" v-b-popover.bottom="'Won'">You <span class="score">{{player_boxes_8}}</span></span>
    </div>
    <div class="col text-center score_div">
      <span id="boxes_tie_8" v-b-popover.bottom="'Tie'">Boxes <span class="score">{{boxes_8}}</span></span>
    </div>
    <div class="col text-left score_div">
      <span id="bot_won_8" v-b-popover.bottom="'Won'">&nbsp;&nbsp;&nbsp;&nbsp;Bot <span class="score">{{bot_boxes_8}}</span></span>
    </div>
  </div>
  <div class="center_div_dots_and_boxes_1" v-if="show_4x4">
    <table cellspacing="0" cellpadding="0" border="0" class="table_4x4">
      <tbody>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_1" :class="[data_move_4['h_1'] ,data_hover_4['h_1']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_2" :class="[data_move_4['h_2'] ,data_hover_4['h_2']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_3" :class="[data_move_4['h_3'] ,data_hover_4['h_3']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_4" :class="[data_move_4['h_4'] ,data_hover_4['h_4']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_1" :class="[data_move_4['v_1'] ,data_hover_4['v_1']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_1']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_2" :class="[data_move_4['v_2'] ,data_hover_4['v_2']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_2']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_3" :class="[data_move_4['v_3'] ,data_hover_4['v_3']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_3']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_4" :class="[data_move_4['v_4'] ,data_hover_4['v_4']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_4']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_5" :class="[data_move_4['v_5'] ,data_hover_4['v_5']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_5" :class="[data_move_4['h_5'] ,data_hover_4['h_5']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_6" :class="[data_move_4['h_6'] ,data_hover_4['h_6']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_7" :class="[data_move_4['h_7'] ,data_hover_4['h_7']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_8" :class="[data_move_4['h_8'] ,data_hover_4['h_8']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_6" :class="[data_move_4['v_6'] ,data_hover_4['v_6']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_5']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_7" :class="[data_move_4['v_7'] ,data_hover_4['v_7']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_6']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_8" :class="[data_move_4['v_8'] ,data_hover_4['v_8']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_7']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_9" :class="[data_move_4['v_9'] ,data_hover_4['v_9']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_8']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_10" :class="[data_move_4['v_10'] ,data_hover_4['v_10']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_9" :class="[data_move_4['h_9'] ,data_hover_4['h_9']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_10" :class="[data_move_4['h_10'] ,data_hover_4['h_10']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_11" :class="[data_move_4['h_11'] ,data_hover_4['h_11']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_12" :class="[data_move_4['h_12'] ,data_hover_4['h_12']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_11" :class="[data_move_4['v_11'] ,data_hover_4['v_11']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_9']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_12" :class="[data_move_4['v_12'] ,data_hover_4['v_12']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_10']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_13" :class="[data_move_4['v_13'] ,data_hover_4['v_13']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_11']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_14" :class="[data_move_4['v_14'] ,data_hover_4['v_14']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_12']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_15" :class="[data_move_4['v_15'] ,data_hover_4['v_15']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_13" :class="[data_move_4['h_13'] ,data_hover_4['h_13']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_14" :class="[data_move_4['h_14'] ,data_hover_4['h_14']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_15" :class="[data_move_4['h_15'] ,data_hover_4['h_15']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_16" :class="[data_move_4['h_16'] ,data_hover_4['h_16']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_16" :class="[data_move_4['v_16'] ,data_hover_4['v_16']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_13']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_17" :class="[data_move_4['v_17'] ,data_hover_4['v_17']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_14']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_18" :class="[data_move_4['v_18'] ,data_hover_4['v_18']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_15']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_19" :class="[data_move_4['v_19'] ,data_hover_4['v_19']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_4['box_16']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_4($event)" id="v_20" :class="[data_move_4['v_20'] ,data_hover_4['v_20']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_17" :class="[data_move_4['h_17'] ,data_hover_4['h_17']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_18" :class="[data_move_4['h_18'] ,data_hover_4['h_18']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_19" :class="[data_move_4['h_19'] ,data_hover_4['h_19']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_4($event)" id="h_20" :class="[data_move_4['h_20'] ,data_hover_4['h_20']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="center_div_dots_and_boxes_2" v-if="show_8x8">
    <table cellspacing="0" cellpadding="0" border="0" class="table_8x8">
      <tbody>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_1" :class="[data_move_8['h_1'] ,data_hover_8['h_1']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_2" :class="[data_move_8['h_2'] ,data_hover_8['h_2']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_3" :class="[data_move_8['h_3'] ,data_hover_8['h_3']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_4" :class="[data_move_8['h_4'] ,data_hover_8['h_4']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_5" :class="[data_move_8['h_5'] ,data_hover_8['h_5']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_6" :class="[data_move_8['h_6'] ,data_hover_8['h_6']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_7" :class="[data_move_8['h_7'] ,data_hover_8['h_7']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_8" :class="[data_move_8['h_8'] ,data_hover_8['h_8']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_1" :class="[data_move_8['v_1'] ,data_hover_8['v_1']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_1']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_2" :class="[data_move_8['v_2'] ,data_hover_8['v_2']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_2']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_3" :class="[data_move_8['v_3'] ,data_hover_8['v_3']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_3']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_4" :class="[data_move_8['v_4'] ,data_hover_8['v_4']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_4']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_5" :class="[data_move_8['v_5'] ,data_hover_8['v_5']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_5']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_6" :class="[data_move_8['v_6'] ,data_hover_8['v_6']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_6']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_7" :class="[data_move_8['v_7'] ,data_hover_8['v_7']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_7']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_8" :class="[data_move_8['v_8'] ,data_hover_8['v_8']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_8']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_9" :class="[data_move_8['v_9'] ,data_hover_8['v_9']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_9" :class="[data_move_8['h_9'] ,data_hover_8['h_9']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_10" :class="[data_move_8['h_10'] ,data_hover_8['h_10']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_11" :class="[data_move_8['h_11'] ,data_hover_8['h_11']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_12" :class="[data_move_8['h_12'] ,data_hover_8['h_12']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_13" :class="[data_move_8['h_13'] ,data_hover_8['h_13']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_14" :class="[data_move_8['h_14'] ,data_hover_8['h_14']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_15" :class="[data_move_8['h_15'] ,data_hover_8['h_15']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_16" :class="[data_move_8['h_16'] ,data_hover_8['h_16']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_10" :class="[data_move_8['v_10'] ,data_hover_8['v_10']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_9']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_11" :class="[data_move_8['v_11'] ,data_hover_8['v_11']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_10']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_12" :class="[data_move_8['v_12'] ,data_hover_8['v_12']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_11']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_13" :class="[data_move_8['v_13'] ,data_hover_8['v_13']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_12']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_14" :class="[data_move_8['v_14'] ,data_hover_8['v_14']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_13']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_15" :class="[data_move_8['v_15'] ,data_hover_8['v_15']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_14']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_16" :class="[data_move_8['v_16'] ,data_hover_8['v_16']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_15']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_17" :class="[data_move_8['v_17'] ,data_hover_8['v_17']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_16']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_18" :class="[data_move_8['v_18'] ,data_hover_8['v_18']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_17" :class="[data_move_8['h_17'] ,data_hover_8['h_17']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_18" :class="[data_move_8['h_18'] ,data_hover_8['h_18']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_19" :class="[data_move_8['h_19'] ,data_hover_8['h_19']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_20" :class="[data_move_8['h_20'] ,data_hover_8['h_20']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_21" :class="[data_move_8['h_21'] ,data_hover_8['h_21']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_22" :class="[data_move_8['h_22'] ,data_hover_8['h_22']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_23" :class="[data_move_8['h_23'] ,data_hover_8['h_23']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_24" :class="[data_move_8['h_24'] ,data_hover_8['h_24']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_19" :class="[data_move_8['v_19'] ,data_hover_8['v_19']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_17']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_20" :class="[data_move_8['v_20'] ,data_hover_8['v_20']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_18']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_21" :class="[data_move_8['v_21'] ,data_hover_8['v_21']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_19']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_22" :class="[data_move_8['v_22'] ,data_hover_8['v_22']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_20']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_23" :class="[data_move_8['v_23'] ,data_hover_8['v_23']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_21']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_24" :class="[data_move_8['v_24'] ,data_hover_8['v_24']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_22']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_25" :class="[data_move_8['v_25'] ,data_hover_8['v_25']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_23']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_26" :class="[data_move_8['v_26'] ,data_hover_8['v_26']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_24']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_27" :class="[data_move_8['v_27'] ,data_hover_8['v_27']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_25" :class="[data_move_8['h_25'] ,data_hover_8['h_25']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_26" :class="[data_move_8['h_26'] ,data_hover_8['h_26']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_27" :class="[data_move_8['h_27'] ,data_hover_8['h_27']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_28" :class="[data_move_8['h_28'] ,data_hover_8['h_28']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_29" :class="[data_move_8['h_29'] ,data_hover_8['h_29']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_30" :class="[data_move_8['h_30'] ,data_hover_8['h_30']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_31" :class="[data_move_8['h_31'] ,data_hover_8['h_31']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_32" :class="[data_move_8['h_32'] ,data_hover_8['h_32']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_28" :class="[data_move_8['v_28'] ,data_hover_8['v_28']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_25']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_29" :class="[data_move_8['v_29'] ,data_hover_8['v_29']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_26']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_30" :class="[data_move_8['v_30'] ,data_hover_8['v_30']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_27']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_31" :class="[data_move_8['v_31'] ,data_hover_8['v_31']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_28']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_32" :class="[data_move_8['v_32'] ,data_hover_8['v_32']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_29']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_33" :class="[data_move_8['v_33'] ,data_hover_8['v_33']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_30']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_34" :class="[data_move_8['v_34'] ,data_hover_8['v_34']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_31']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_35" :class="[data_move_8['v_35'] ,data_hover_8['v_35']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_32']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_36" :class="[data_move_8['v_36'] ,data_hover_8['v_36']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_33" :class="[data_move_8['h_33'] ,data_hover_8['h_33']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_34" :class="[data_move_8['h_34'] ,data_hover_8['h_34']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_35" :class="[data_move_8['h_35'] ,data_hover_8['h_35']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_36" :class="[data_move_8['h_36'] ,data_hover_8['h_36']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_37" :class="[data_move_8['h_37'] ,data_hover_8['h_37']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_38" :class="[data_move_8['h_38'] ,data_hover_8['h_38']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_39" :class="[data_move_8['h_39'] ,data_hover_8['h_39']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_40" :class="[data_move_8['h_40'] ,data_hover_8['h_40']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_37" :class="[data_move_8['v_37'] ,data_hover_8['v_37']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_33']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_38" :class="[data_move_8['v_38'] ,data_hover_8['v_38']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_34']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_39" :class="[data_move_8['v_39'] ,data_hover_8['v_39']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_35']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_40" :class="[data_move_8['v_40'] ,data_hover_8['v_40']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_36']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_41" :class="[data_move_8['v_41'] ,data_hover_8['v_41']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_37']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_42" :class="[data_move_8['v_42'] ,data_hover_8['v_42']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_38']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_43" :class="[data_move_8['v_43'] ,data_hover_8['v_43']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_39']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_44" :class="[data_move_8['v_44'] ,data_hover_8['v_44']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_40']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_45" :class="[data_move_8['v_45'] ,data_hover_8['v_45']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_41" :class="[data_move_8['h_41'] ,data_hover_8['h_41']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_42" :class="[data_move_8['h_42'] ,data_hover_8['h_42']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_43" :class="[data_move_8['h_43'] ,data_hover_8['h_43']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_44" :class="[data_move_8['h_44'] ,data_hover_8['h_44']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_45" :class="[data_move_8['h_45'] ,data_hover_8['h_45']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_46" :class="[data_move_8['h_46'] ,data_hover_8['h_46']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_47" :class="[data_move_8['h_47'] ,data_hover_8['h_47']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_48" :class="[data_move_8['h_48'] ,data_hover_8['h_48']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_46" :class="[data_move_8['v_46'] ,data_hover_8['v_46']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_41']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_47" :class="[data_move_8['v_47'] ,data_hover_8['v_47']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_42']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_48" :class="[data_move_8['v_48'] ,data_hover_8['v_48']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_43']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_49" :class="[data_move_8['v_49'] ,data_hover_8['v_49']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_44']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_50" :class="[data_move_8['v_50'] ,data_hover_8['v_50']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_45']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_51" :class="[data_move_8['v_51'] ,data_hover_8['v_51']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_46']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_52" :class="[data_move_8['v_52'] ,data_hover_8['v_52']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_47']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_53" :class="[data_move_8['v_53'] ,data_hover_8['v_53']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_48']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_54" :class="[data_move_8['v_54'] ,data_hover_8['v_54']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_49" :class="[data_move_8['h_49'] ,data_hover_8['h_49']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_50" :class="[data_move_8['h_50'] ,data_hover_8['h_50']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_51" :class="[data_move_8['h_51'] ,data_hover_8['h_51']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_52" :class="[data_move_8['h_52'] ,data_hover_8['h_52']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_53" :class="[data_move_8['h_53'] ,data_hover_8['h_53']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_54" :class="[data_move_8['h_54'] ,data_hover_8['h_54']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_55" :class="[data_move_8['h_55'] ,data_hover_8['h_55']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_56" :class="[data_move_8['h_56'] ,data_hover_8['h_56']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_55" :class="[data_move_8['v_55'] ,data_hover_8['v_55']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_49']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_56" :class="[data_move_8['v_56'] ,data_hover_8['v_56']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_50']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_57" :class="[data_move_8['v_57'] ,data_hover_8['v_57']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_51']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_58" :class="[data_move_8['v_58'] ,data_hover_8['v_58']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_52']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_59" :class="[data_move_8['v_59'] ,data_hover_8['v_59']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_53']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_60" :class="[data_move_8['v_60'] ,data_hover_8['v_60']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_54']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_61" :class="[data_move_8['v_61'] ,data_hover_8['v_61']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_55']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_62" :class="[data_move_8['v_62'] ,data_hover_8['v_62']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_56']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_63" :class="[data_move_8['v_63'] ,data_hover_8['v_63']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_57" :class="[data_move_8['h_57'] ,data_hover_8['h_57']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_58" :class="[data_move_8['h_58'] ,data_hover_8['h_58']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_59" :class="[data_move_8['h_59'] ,data_hover_8['h_59']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_60" :class="[data_move_8['h_60'] ,data_hover_8['h_60']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_61" :class="[data_move_8['h_61'] ,data_hover_8['h_61']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_62" :class="[data_move_8['h_62'] ,data_hover_8['h_62']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_63" :class="[data_move_8['h_63'] ,data_hover_8['h_63']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_64" :class="[data_move_8['h_64'] ,data_hover_8['h_64']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_64" :class="[data_move_8['v_64'] ,data_hover_8['v_64']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_57']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_65" :class="[data_move_8['v_65'] ,data_hover_8['v_65']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_58']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_66" :class="[data_move_8['v_66'] ,data_hover_8['v_66']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_59']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_67" :class="[data_move_8['v_67'] ,data_hover_8['v_67']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_60']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_68" :class="[data_move_8['v_68'] ,data_hover_8['v_68']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_61']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_69" :class="[data_move_8['v_69'] ,data_hover_8['v_69']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_62']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_70" :class="[data_move_8['v_70'] ,data_hover_8['v_70']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_63']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_71" :class="[data_move_8['v_71'] ,data_hover_8['v_71']]"></button></td>
          <td align="center" valign="middle" class="fullbox" :class="[data_boxes_8['box_64']]"></td>
          <td align="center" valign="middle" class="vertical" id="line_v"><button type="button" class="line_v" @click="btn_clicked_8($event)" id="v_72" :class="[data_move_8['v_72'] ,data_hover_8['v_72']]"></button></td>
        </tr>
        <tr valign="top">
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_65" :class="[data_move_8['h_65'] ,data_hover_8['h_65']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_66" :class="[data_move_8['h_66'] ,data_hover_8['h_66']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_67" :class="[data_move_8['h_67'] ,data_hover_8['h_67']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_68" :class="[data_move_8['h_68'] ,data_hover_8['h_68']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_69" :class="[data_move_8['h_69'] ,data_hover_8['h_69']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_70" :class="[data_move_8['h_70'] ,data_hover_8['h_70']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_71" :class="[data_move_8['h_71'] ,data_hover_8['h_71']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
          <td align="center" valign="middle" class="horizontal" id="line_h"><button type="button" class="line_h" @click="btn_clicked_8($event)" id="h_72" :class="[data_move_8['h_72'] ,data_hover_8['h_72']]"></button></td>
          <td align="center" valign="middle"><img src="../../assets/dot.png" class="dot_image"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row options_row">
    <div class="col text-right p-0 m-0 ">
      <div class="switch-field switch_one">
        <input type="radio" id="radio-three" name="switch-two" v-model="mode" value="4x4" :disabled="disable_mode" />
        <label for="radio-three">4x4</label>
        <input type="radio" id="radio-four" name="switch-two" v-model="mode" value="8x8" :disabled="disable_mode" />
        <label for="radio-four">8x8</label>
      </div>
    </div>
    <div class="col text-center p-0 m-0 ">
      <div class="switch-field switch_two">
        <input type="radio" id="radio-one" name="switch-one" v-model="current_move" value="player" :disabled="disable_radio" />
        <label for="radio-one">You</label>
        <input type="radio" id="radio-two" name="switch-one" v-model="current_move" value="bot" :disabled="disable_radio" />
        <label for="radio-two">Bot</label>
      </div>
    </div>
    <div class="col text-left p-0 m-0 ">
      <button type="button" class="reset_button" name="button" @click="reset()">Reset</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Dotsandboxes',
  data() {
    return {
      boxed: false,
      show_4x4: true,
      show_8x8: false,
      move_count: 0,
      boxes_4: 16,
      boxes_8: 64,
      player_boxes_4: 0,
      player_boxes_8: 0,
      bot_boxes_4: 0,
      bot_boxes_8: 0,
      current_move: 'player',
      player_lock: false,
      reset_lock: false,
      mode: '4x4',
      disable_radio: false,
      disable_mode: false,
      data_hover_4: {
        h_1: 'hover_line',
        h_2: 'hover_line',
        h_3: 'hover_line',
        h_4: 'hover_line',
        h_5: 'hover_line',
        h_6: 'hover_line',
        h_7: 'hover_line',
        h_8: 'hover_line',
        h_9: 'hover_line',
        h_10: 'hover_line',
        h_11: 'hover_line',
        h_12: 'hover_line',
        h_13: 'hover_line',
        h_14: 'hover_line',
        h_15: 'hover_line',
        h_16: 'hover_line',
        h_17: 'hover_line',
        h_18: 'hover_line',
        h_19: 'hover_line',
        h_20: 'hover_line',

        v_1: 'hover_line',
        v_2: 'hover_line',
        v_3: 'hover_line',
        v_4: 'hover_line',
        v_5: 'hover_line',
        v_6: 'hover_line',
        v_7: 'hover_line',
        v_8: 'hover_line',
        v_9: 'hover_line',
        v_10: 'hover_line',
        v_11: 'hover_line',
        v_12: 'hover_line',
        v_13: 'hover_line',
        v_14: 'hover_line',
        v_15: 'hover_line',
        v_16: 'hover_line',
        v_17: 'hover_line',
        v_18: 'hover_line',
        v_19: 'hover_line',
        v_20: 'hover_line',
      },
      data_move_4: {
        h_1: '',
        h_2: '',
        h_3: '',
        h_4: '',
        h_5: '',
        h_6: '',
        h_7: '',
        h_8: '',
        h_9: '',
        h_10: '',
        h_11: '',
        h_12: '',
        h_13: '',
        h_14: '',
        h_15: '',
        h_16: '',
        h_17: '',
        h_18: '',
        h_19: '',
        h_20: '',

        v_1: '',
        v_2: '',
        v_3: '',
        v_4: '',
        v_5: '',
        v_6: '',
        v_7: '',
        v_8: '',
        v_9: '',
        v_10: '',
        v_11: '',
        v_12: '',
        v_13: '',
        v_14: '',
        v_15: '',
        v_16: '',
        v_17: '',
        v_18: '',
        v_19: '',
        v_20: '',
      },
      data_boxes_4: {
        box_1: '',
        box_2: '',
        box_3: '',
        box_4: '',
        box_5: '',
        box_6: '',
        box_7: '',
        box_8: '',
        box_9: '',
        box_10: '',
        box_11: '',
        box_12: '',
        box_13: '',
        box_14: '',
        box_15: '',
        box_16: ''
      },
      data_hover_8: {
        h_1: 'hover_line',
        h_2: 'hover_line',
        h_3: 'hover_line',
        h_4: 'hover_line',
        h_5: 'hover_line',
        h_6: 'hover_line',
        h_7: 'hover_line',
        h_8: 'hover_line',
        h_9: 'hover_line',
        h_10: 'hover_line',
        h_11: 'hover_line',
        h_12: 'hover_line',
        h_13: 'hover_line',
        h_14: 'hover_line',
        h_15: 'hover_line',
        h_16: 'hover_line',
        h_17: 'hover_line',
        h_18: 'hover_line',
        h_19: 'hover_line',
        h_20: 'hover_line',
        h_21: 'hover_line',
        h_22: 'hover_line',
        h_23: 'hover_line',
        h_24: 'hover_line',
        h_25: 'hover_line',
        h_26: 'hover_line',
        h_27: 'hover_line',
        h_28: 'hover_line',
        h_29: 'hover_line',
        h_30: 'hover_line',
        h_31: 'hover_line',
        h_32: 'hover_line',
        h_33: 'hover_line',
        h_34: 'hover_line',
        h_35: 'hover_line',
        h_36: 'hover_line',
        h_37: 'hover_line',
        h_38: 'hover_line',
        h_39: 'hover_line',
        h_40: 'hover_line',
        h_41: 'hover_line',
        h_42: 'hover_line',
        h_43: 'hover_line',
        h_44: 'hover_line',
        h_45: 'hover_line',
        h_46: 'hover_line',
        h_47: 'hover_line',
        h_48: 'hover_line',
        h_49: 'hover_line',
        h_50: 'hover_line',
        h_51: 'hover_line',
        h_52: 'hover_line',
        h_53: 'hover_line',
        h_54: 'hover_line',
        h_55: 'hover_line',
        h_56: 'hover_line',
        h_57: 'hover_line',
        h_58: 'hover_line',
        h_59: 'hover_line',
        h_60: 'hover_line',
        h_61: 'hover_line',
        h_62: 'hover_line',
        h_63: 'hover_line',
        h_64: 'hover_line',
        h_65: 'hover_line',
        h_66: 'hover_line',
        h_67: 'hover_line',
        h_68: 'hover_line',
        h_69: 'hover_line',
        h_70: 'hover_line',
        h_71: 'hover_line',
        h_72: 'hover_line',

        v_1: 'hover_line',
        v_2: 'hover_line',
        v_3: 'hover_line',
        v_4: 'hover_line',
        v_5: 'hover_line',
        v_6: 'hover_line',
        v_7: 'hover_line',
        v_8: 'hover_line',
        v_9: 'hover_line',
        v_10: 'hover_line',
        v_11: 'hover_line',
        v_12: 'hover_line',
        v_13: 'hover_line',
        v_14: 'hover_line',
        v_15: 'hover_line',
        v_16: 'hover_line',
        v_17: 'hover_line',
        v_18: 'hover_line',
        v_19: 'hover_line',
        v_20: 'hover_line',
        v_21: 'hover_line',
        v_22: 'hover_line',
        v_23: 'hover_line',
        v_24: 'hover_line',
        v_25: 'hover_line',
        v_26: 'hover_line',
        v_27: 'hover_line',
        v_28: 'hover_line',
        v_29: 'hover_line',
        v_30: 'hover_line',
        v_31: 'hover_line',
        v_32: 'hover_line',
        v_33: 'hover_line',
        v_34: 'hover_line',
        v_35: 'hover_line',
        v_36: 'hover_line',
        v_37: 'hover_line',
        v_38: 'hover_line',
        v_39: 'hover_line',
        v_40: 'hover_line',
        v_41: 'hover_line',
        v_42: 'hover_line',
        v_43: 'hover_line',
        v_44: 'hover_line',
        v_45: 'hover_line',
        v_46: 'hover_line',
        v_47: 'hover_line',
        v_48: 'hover_line',
        v_49: 'hover_line',
        v_50: 'hover_line',
        v_51: 'hover_line',
        v_52: 'hover_line',
        v_53: 'hover_line',
        v_54: 'hover_line',
        v_55: 'hover_line',
        v_56: 'hover_line',
        v_57: 'hover_line',
        v_58: 'hover_line',
        v_59: 'hover_line',
        v_60: 'hover_line',
        v_61: 'hover_line',
        v_62: 'hover_line',
        v_63: 'hover_line',
        v_64: 'hover_line',
        v_65: 'hover_line',
        v_66: 'hover_line',
        v_67: 'hover_line',
        v_68: 'hover_line',
        v_69: 'hover_line',
        v_70: 'hover_line',
        v_71: 'hover_line',
        v_72: 'hover_line',
      },
      data_move_8: {
        h_1: '',
        h_2: '',
        h_3: '',
        h_4: '',
        h_5: '',
        h_6: '',
        h_7: '',
        h_8: '',
        h_9: '',
        h_10: '',
        h_11: '',
        h_12: '',
        h_13: '',
        h_14: '',
        h_15: '',
        h_16: '',
        h_17: '',
        h_18: '',
        h_19: '',
        h_20: '',
        h_21: '',
        h_22: '',
        h_23: '',
        h_24: '',
        h_25: '',
        h_26: '',
        h_27: '',
        h_28: '',
        h_29: '',
        h_30: '',
        h_31: '',
        h_32: '',
        h_33: '',
        h_34: '',
        h_35: '',
        h_36: '',
        h_37: '',
        h_38: '',
        h_39: '',
        h_40: '',
        h_41: '',
        h_42: '',
        h_43: '',
        h_44: '',
        h_45: '',
        h_46: '',
        h_47: '',
        h_48: '',
        h_49: '',
        h_50: '',
        h_51: '',
        h_52: '',
        h_53: '',
        h_54: '',
        h_55: '',
        h_56: '',
        h_57: '',
        h_58: '',
        h_59: '',
        h_60: '',
        h_61: '',
        h_62: '',
        h_63: '',
        h_64: '',
        h_65: '',
        h_66: '',
        h_67: '',
        h_68: '',
        h_69: '',
        h_70: '',
        h_71: '',
        h_72: '',

        v_1: '',
        v_2: '',
        v_3: '',
        v_4: '',
        v_5: '',
        v_6: '',
        v_7: '',
        v_8: '',
        v_9: '',
        v_10: '',
        v_11: '',
        v_12: '',
        v_13: '',
        v_14: '',
        v_15: '',
        v_16: '',
        v_17: '',
        v_18: '',
        v_19: '',
        v_20: '',
        v_21: '',
        v_22: '',
        v_23: '',
        v_24: '',
        v_25: '',
        v_26: '',
        v_27: '',
        v_28: '',
        v_29: '',
        v_30: '',
        v_31: '',
        v_32: '',
        v_33: '',
        v_34: '',
        v_35: '',
        v_36: '',
        v_37: '',
        v_38: '',
        v_39: '',
        v_40: '',
        v_41: '',
        v_42: '',
        v_43: '',
        v_44: '',
        v_45: '',
        v_46: '',
        v_47: '',
        v_48: '',
        v_49: '',
        v_50: '',
        v_51: '',
        v_52: '',
        v_53: '',
        v_54: '',
        v_55: '',
        v_56: '',
        v_57: '',
        v_58: '',
        v_59: '',
        v_60: '',
        v_61: '',
        v_62: '',
        v_63: '',
        v_64: '',
        v_65: '',
        v_66: '',
        v_67: '',
        v_68: '',
        v_69: '',
        v_70: '',
        v_71: '',
        v_72: '',
      },
      data_boxes_8: {
        box_1: '',
        box_2: '',
        box_3: '',
        box_4: '',
        box_5: '',
        box_6: '',
        box_7: '',
        box_8: '',
        box_9: '',
        box_10: '',
        box_11: '',
        box_12: '',
        box_13: '',
        box_14: '',
        box_15: '',
        box_16: '',
        box_17: '',
        box_18: '',
        box_19: '',
        box_20: '',
        box_21: '',
        box_22: '',
        box_23: '',
        box_24: '',
        box_25: '',
        box_26: '',
        box_27: '',
        box_28: '',
        box_29: '',
        box_30: '',
        box_31: '',
        box_32: '',
        box_33: '',
        box_34: '',
        box_35: '',
        box_36: '',
        box_37: '',
        box_38: '',
        box_39: '',
        box_40: '',
        box_41: '',
        box_42: '',
        box_43: '',
        box_44: '',
        box_45: '',
        box_46: '',
        box_47: '',
        box_48: '',
        box_49: '',
        box_50: '',
        box_51: '',
        box_52: '',
        box_53: '',
        box_54: '',
        box_55: '',
        box_56: '',
        box_57: '',
        box_58: '',
        box_59: '',
        box_60: '',
        box_61: '',
        box_62: '',
        box_63: '',
        box_64: '',
      },
    }
  },
  mounted() {
    this.$root.$emit('bv::disable::popover', 'player_won_4');
    this.$root.$emit('bv::disable::popover', 'bot_won_4');
    this.$root.$emit('bv::disable::popover', 'boxes_tie_4');
    this.$root.$emit('bv::disable::popover', 'player_won_8');
    this.$root.$emit('bv::disable::popover', 'bot_won_8');
    this.$root.$emit('bv::disable::popover', 'boxes_tie_8');
  },
  beforeRouteLeave (to, from, next) {
    next();
    this.reset();
},
  methods: {
    btn_clicked_4(e) {
      if (this.current_move == "player" && this.player_lock == false) {
        this.player_lock = true;
        this.move_count++;
        this.disable_mode = true;
        this.disable_radio = true;
        this.data_hover_4[e.target.id] = '';
        this.data_move_4[e.target.id] = 'player_line';
        document.getElementById(e.target.id).disabled = true;
        this.check_boxes_4();
      }
    },
    bot_clicked_4() {
      if (this.current_move == "bot") {
        this.reset_lock = true;
        this.move_count++;
        this.disable_mode = true;
        this.disable_radio = true;

        var bot_value = '';

        var first = 0;
        var second = 4;
        var third = 0;
        var fourth = 1;
        for (var i = 1; i < 17; i++) {
          var add = 1;
          first = i;
          second = second + add;
          third = (i == 5 || i == 9 || i == 13) ? third + 2 : third + add;
          fourth = (i == 5 || i == 9 || i == 13) ? fourth + 2 : fourth + add;

          var box = 'box_' + i;
          var h_first = 'h_' + first;
          var h_second = 'h_' + second;
          var v_first = 'v_' + third;
          var v_second = 'v_' + fourth;
          if (this.data_boxes_4[box] == '' && this.data_move_4[h_first] == '' && this.data_move_4[h_second] != '' && this.data_move_4[v_first] != '' && this.data_move_4[v_second] != '') {
            bot_value = h_first;
          } else if (this.data_boxes_4[box] == '' && this.data_move_4[h_first] != '' && this.data_move_4[h_second] == '' && this.data_move_4[v_first] != '' && this.data_move_4[v_second] != '') {
            bot_value = h_second;
          } else if (this.data_boxes_4[box] == '' && this.data_move_4[h_first] != '' && this.data_move_4[h_second] != '' && this.data_move_4[v_first] == '' && this.data_move_4[v_second] != '') {
            bot_value = v_first;
          } else if (this.data_boxes_4[box] == '' && this.data_move_4[h_first] != '' && this.data_move_4[h_second] != '' && this.data_move_4[v_first] != '' && this.data_move_4[v_second] == '') {
            bot_value = v_second;
          }
        }


        if (bot_value != '') {
          setTimeout(function() {
            this.data_hover_4[bot_value] = '';
            this.data_move_4[bot_value] = 'bot_line';
            document.getElementById(bot_value).disabled = true;
            this.check_boxes_4();
          }.bind(this), 700);
        } else {
          var random_number = Math.floor(Math.random() * 20) + 1;
          var random_keyword_array = ['h_', 'v_'];
          var random_keyword = random_keyword_array[Math.floor(Math.random() * 2)];
          if (this.data_move_4[random_keyword + random_number] == '') {
            setTimeout(function() {
              this.data_hover_4[random_keyword + random_number] = '';
              this.data_move_4[random_keyword + random_number] = 'bot_line';
              document.getElementById(random_keyword + random_number).disabled = true;
              this.check_boxes_4();
            }.bind(this), 700);
          } else {
            this.bot_clicked_4();
          }
        }

      }
    },
    check_boxes_4() {
      var first = 0;
      var second = 4;
      var third = 0;
      var fourth = 1;
      for (var i = 1; i < 17; i++) {
        var add = 1;
        first = i;
        second = second + add;
        third = (i == 5 || i == 9 || i == 13) ? third + 2 : third + add;
        fourth = (i == 5 || i == 9 || i == 13) ? fourth + 2 : fourth + add;

        var box = 'box_' + i;
        var h_first = 'h_' + first;
        var h_second = 'h_' + second;
        var v_first = 'v_' + third;
        var v_second = 'v_' + fourth;
        if (this.data_boxes_4[box] == '' && this.data_move_4[h_first] != '' && this.data_move_4[h_second] != '' && this.data_move_4[v_first] != '' && this.data_move_4[v_second] != '') {
          this.boxed = true;
          if (this.current_move == "player") {
            this.boxes_4--;
            this.player_boxes_4++;
            this.data_boxes_4[box] = "player_box";
          } else if (this.current_move == "bot") {
            this.boxes_4--;
            this.bot_boxes_4++;
            this.data_boxes_4[box] = "bot_box";
          }
        }
      }

      if (this.boxed == false && this.current_move == "player") {
        this.current_move = "bot";
        this.bot_clicked_4();
      } else if (this.boxed == false && this.current_move == "bot") {
        this.reset_lock = false;
        this.player_lock = false;
        this.current_move = "player";
      }

      if (this.boxed == true && this.current_move == "player") {
        this.player_lock = false;
        this.current_move = "player";
        this.boxed = false;
        if (this.boxes_4 == 0 && this.player_boxes_4 > this.bot_boxes_4) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'player_won_4');
          this.$root.$emit('bv::show::popover', 'player_won_4');
          for (var a = 1; a < 21; a++) {
            this.data_move_4["h_" + a] = '';
            this.data_move_4["v_" + a] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'player_won_4');
            this.$root.$emit('bv::disable::popover', 'player_won_4');
          }.bind(this), 3000);

        } else if (this.boxes_4 == 0 && this.player_boxes_4 < this.bot_boxes_4) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'bot_won_4');
          this.$root.$emit('bv::show::popover', 'bot_won_4');
          for (var b = 1; b < 21; b++) {
            this.data_move_4["h_" + b] = '';
            this.data_move_4["v_" + b] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'bot_won_4');
            this.$root.$emit('bv::disable::popover', 'bot_won_4');
          }.bind(this), 3000);
        } else if (this.boxes_4 == 0 && this.player_boxes_4 == this.bot_boxes_4) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'boxes_tie_4');
          this.$root.$emit('bv::show::popover', 'boxes_tie_4');
          for (var c = 1; c < 21; c++) {
            this.data_move_4["h_" + c] = '';
            this.data_move_4["v_" + c] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'boxes_tie_4');
            this.$root.$emit('bv::disable::popover', 'boxes_tie_4');
          }.bind(this), 3000);
        }
      } else if (this.boxed == true && this.current_move == "bot") {
        this.current_move = "bot";
        this.boxed = false;
        if (this.boxes_4 == 0 && this.player_boxes_4 > this.bot_boxes_4) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'player_won_4');
          this.$root.$emit('bv::show::popover', 'player_won_4');
          for (var d = 1; d < 21; d++) {
            this.data_move_4["h_" + d] = '';
            this.data_move_4["v_" + d] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'player_won_4');
            this.$root.$emit('bv::disable::popover', 'player_won_4');
          }.bind(this), 3000);
        } else if (this.boxes_4 == 0 && this.player_boxes_4 < this.bot_boxes_4) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'bot_won_4');
          this.$root.$emit('bv::show::popover', 'bot_won_4');
          for (var e = 1; e < 21; e++) {
            this.data_move_4["h_" + e] = '';
            this.data_move_4["v_" + e] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'bot_won_4');
            this.$root.$emit('bv::disable::popover', 'bot_won_4');
          }.bind(this), 3000);
        } else if (this.boxes_4 == 0 && this.player_boxes_4 == this.bot_boxes_4) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'boxes_tie_4');
          this.$root.$emit('bv::show::popover', 'boxes_tie_4');
          for (var f = 1; f < 21; f++) {
            this.data_move_4["h_" + f] = '';
            this.data_move_4["v_" + f] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'boxes_tie_4');
            this.$root.$emit('bv::disable::popover', 'boxes_tie_4');
          }.bind(this), 3000);
        } else {
          this.bot_clicked_4();
        }
      }
    },

    btn_clicked_8(e) {
      if (this.current_move == "player" && this.player_lock == false) {
        this.player_lock = true;
        this.move_count++;
        this.disable_mode = true;
        this.disable_radio = true;
        this.data_hover_8[e.target.id] = '';
        this.data_move_8[e.target.id] = 'player_line';
        document.getElementById(e.target.id).disabled = true;
        this.check_boxes_8();
      }
    },
    bot_clicked_8() {
      if (this.current_move == "bot") {
        this.reset_lock = true;
        this.move_count++;
        this.disable_mode = true;
        this.disable_radio = true;

        var bot_value = '';

        var first = 0;
        var second = 8;
        var third = 0;
        var fourth = 1;
        for (var i = 1; i < 65; i++) {
          var add = 1;
          first = i;
          second = second + add;
          third = (i == 9 || i == 17 || i == 25 || i == 33 || i == 41 || i == 49 || i == 57) ? third + 2 : third + add;
          fourth = (i == 9 || i == 17 || i == 25 || i == 33 || i == 41 || i == 49 || i == 57) ? fourth + 2 : fourth + add;

          var box = 'box_' + i;
          var h_first = 'h_' + first;
          var h_second = 'h_' + second;
          var v_first = 'v_' + third;
          var v_second = 'v_' + fourth;
          if (this.data_boxes_8[box] == '' && this.data_move_8[h_first] == '' && this.data_move_8[h_second] != '' && this.data_move_8[v_first] != '' && this.data_move_8[v_second] != '') {
            bot_value = h_first;
          } else if (this.data_boxes_8[box] == '' && this.data_move_8[h_first] != '' && this.data_move_8[h_second] == '' && this.data_move_8[v_first] != '' && this.data_move_8[v_second] != '') {
            bot_value = h_second;
          } else if (this.data_boxes_8[box] == '' && this.data_move_8[h_first] != '' && this.data_move_8[h_second] != '' && this.data_move_8[v_first] == '' && this.data_move_8[v_second] != '') {
            bot_value = v_first;
          } else if (this.data_boxes_8[box] == '' && this.data_move_8[h_first] != '' && this.data_move_8[h_second] != '' && this.data_move_8[v_first] != '' && this.data_move_8[v_second] == '') {
            bot_value = v_second;
          }
        }


        if (bot_value != '') {
          setTimeout(function() {
            this.data_hover_8[bot_value] = '';
            this.data_move_8[bot_value] = 'bot_line';
            document.getElementById(bot_value).disabled = true;
            this.check_boxes_8();
          }.bind(this), 700);
        } else {
          var random_number = Math.floor(Math.random() * 72) + 1;
          var random_keyword_array = ['h_', 'v_'];
          var random_keyword = random_keyword_array[Math.floor(Math.random() * 2)];
          if (this.data_move_8[random_keyword + random_number] == '') {
            setTimeout(function() {
              this.data_hover_8[random_keyword + random_number] = '';
              this.data_move_8[random_keyword + random_number] = 'bot_line';
              document.getElementById(random_keyword + random_number).disabled = true;
              this.check_boxes_8();
            }.bind(this), 700);
          } else {
            this.bot_clicked_8();
          }
        }

      }
    },
    check_boxes_8() {
      var first = 0;
      var second = 8;
      var third = 0;
      var fourth = 1;
      for (var i = 1; i < 65; i++) {
        var add = 1;
        first = i;
        second = second + add;
        third = (i == 9 || i == 17 || i == 25 || i == 33 || i == 41 || i == 49 || i == 57) ? third + 2 : third + add;
        fourth = (i == 9 || i == 17 || i == 25 || i == 33 || i == 41 || i == 49 || i == 57) ? fourth + 2 : fourth + add;

        var box = 'box_' + i;
        var h_first = 'h_' + first;
        var h_second = 'h_' + second;
        var v_first = 'v_' + third;
        var v_second = 'v_' + fourth;
        if (this.data_boxes_8[box] == '' && this.data_move_8[h_first] != '' && this.data_move_8[h_second] != '' && this.data_move_8[v_first] != '' && this.data_move_8[v_second] != '') {
          this.boxed = true;
          if (this.current_move == "player") {
            this.boxes_8--;
            this.player_boxes_8++;
            this.data_boxes_8[box] = "player_box";
          } else if (this.current_move == "bot") {
            this.boxes_8--;
            this.bot_boxes_8++;
            this.data_boxes_8[box] = "bot_box";
          }
        }
      }

      if (this.boxed == false && this.current_move == "player") {
        this.current_move = "bot";
        this.bot_clicked_8();
      } else if (this.boxed == false && this.current_move == "bot") {
        this.reset_lock = false;
        this.player_lock = false;
        this.current_move = "player";
      }
      if (this.boxed == true && this.current_move == "player") {
        this.player_lock = false;
        this.current_move = "player";
        this.boxed = false;
        if (this.boxes_8 == 0 && this.player_boxes_8 > this.bot_boxes_8) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'player_won_8');
          this.$root.$emit('bv::show::popover', 'player_won_8');
          for (var aa = 1; aa < 73; aa++) {
            this.data_move_8["h_" + aa] = '';
            this.data_move_8["v_" + aa] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'player_won_8');
            this.$root.$emit('bv::disable::popover', 'player_won_8');
          }.bind(this), 3000);
        } else if (this.boxes_8 == 0 && this.player_boxes_8 < this.bot_boxes_8) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'bot_won_8');
          this.$root.$emit('bv::show::popover', 'bot_won_8');
          for (var bb = 1; bb < 21; bb++) {
            this.data_move_8["h_" + bb] = '';
            this.data_move_8["v_" + bb] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'bot_won_8');
            this.$root.$emit('bv::disable::popover', 'bot_won_8');
          }.bind(this), 3000);
        } else if (this.boxes_8 == 0 && this.player_boxes_8 == this.bot_boxes_8) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'boxes_tie_8');
          this.$root.$emit('bv::show::popover', 'boxes_tie_8');
          for (var cc = 1; cc < 21; cc++) {
            this.data_move_8["h_" + cc] = '';
            this.data_move_8["v_" + cc] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'boxes_tie_8');
            this.$root.$emit('bv::disable::popover', 'boxes_tie_8');
          }.bind(this), 3000);
        }
      } else if (this.boxed == true && this.current_move == "bot") {
        this.current_move = "bot";
        this.boxed = false;
        if (this.boxes_8 == 0 && this.player_boxes_8 > this.bot_boxes_8) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'player_won_8');
          this.$root.$emit('bv::show::popover', 'player_won_8');
          for (var dd = 1; dd < 73; dd++) {
            this.data_move_8["h_" + dd] = '';
            this.data_move_8["v_" + dd] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'player_won_8');
            this.$root.$emit('bv::disable::popover', 'player_won_8');
          }.bind(this), 3000);
        } else if (this.boxes_8 == 0 && this.player_boxes_8 < this.bot_boxes_8) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'bot_won_8');
          this.$root.$emit('bv::show::popover', 'bot_won_8');
          for (var ee = 1; ee < 21; ee++) {
            this.data_move_8["h_" + ee] = '';
            this.data_move_8["v_" + ee] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'bot_won_8');
            this.$root.$emit('bv::disable::popover', 'bot_won_8');
          }.bind(this), 3000);
        } else if (this.boxes_8 == 0 && this.player_boxes_8 == this.bot_boxes_8) {
          this.reset_lock = true;
          this.$root.$emit('bv::enable::popover', 'boxes_tie_8');
          this.$root.$emit('bv::show::popover', 'boxes_tie_8');
          for (var ff = 1; ff < 21; ff++) {
            this.data_move_8["h_" + ff] = '';
            this.data_move_8["v_" + ff] = '';
          }
          setTimeout(function() {
            this.reset_lock = false;
            this.$root.$emit('bv::hide::popover', 'boxes_tie_8');
            this.$root.$emit('bv::disable::popover', 'boxes_tie_8');
          }.bind(this), 3000);
        } else {
          this.bot_clicked_8();
        }
      }
    },

    reset() {
      if (this.reset_lock == false) {
        this.current_move = 'player';
        this.player_lock = false;
        this.boxes_4 = 16;
        this.boxes_8 = 64;
        this.player_boxes_4 = 0;
        this.player_boxes_8 = 0;
        this.bot_boxes_4 = 0;
        this.bot_boxes_8 = 0;
        this.disable_radio = false;
        this.disable_mode = false;
        this.move_count = 0;

        for (var i = 1; i < 21; i++) {
          var data_4_h = "h_";
          var data_4_v = "v_";
          this.data_hover_4[data_4_h + i] = 'hover_line';
          this.data_hover_4[data_4_v + i] = 'hover_line';
          this.data_move_4[data_4_h + i] = '';
          this.data_move_4[data_4_v + i] = '';
          document.getElementById(data_4_h + i).disabled = false;
          document.getElementById(data_4_v + i).disabled = false;
        }
        for (var q = 1; q < 17; q++) {
          this.data_boxes_4["box_" + q] = '';
        }
        for (var j = 1; j < 73; j++) {
          var data_8_h = "h_";
          var data_8_v = "v_";
          this.data_hover_8[data_8_h + j] = 'hover_line';
          this.data_hover_8[data_8_v + j] = 'hover_line';
          this.data_move_8[data_8_h + j] = '';
          this.data_move_8[data_8_v + j] = '';
          document.getElementById(data_8_h + j).disabled = false;
          document.getElementById(data_8_v + j).disabled = false;
        }
        for (var r = 1; r < 65; r++) {
          this.data_boxes_8["box_" + r] = '';
        }
      }
    }
  },
  watch: {
    current_move: function(new_value) {
      if (this.move_count == 0 && new_value == "bot") {
        if (this.mode == "4x4") {
          this.bot_clicked_4();
        } else if (this.mode == "8x8") {
          this.bot_clicked_8();
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    mode: function(new_value) {
      if (new_value == "8x8") {
        this.show_4x4 = false;
        this.show_8x8 = true;
      } else if (new_value == "4x4") {
        this.show_8x8 = false;
        this.show_4x4 = true;
      }
    },
  },
}
</script>

<style>

</style>
